export const APP_NAME = 'contactabilidad';
